import React from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  IconButton,
  Tooltip,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../contexts/NotificationContext';
import { PreferencesForm } from '../components/notifications/PreferencesForm';

/**
 * NotificationPreferences Page
 * Manage notification settings and preferences
 */
const NotificationPreferences: React.FC = () => {
  const navigate = useNavigate();
  const { preferences, updatePreferences, loading } = useNotifications();

  if (!preferences) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper sx={{ p: 3 }}>
          <Typography>Loading preferences...</Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Tooltip title="Back to Notifications">
            <IconButton onClick={() => navigate('/notifications')} sx={{ mr: 2 }}>
              <ArrowBackIcon />
            </IconButton>
          </Tooltip>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Notification Preferences
          </Typography>
        </Box>

        <Breadcrumbs>
          <Link
            component="button"
            variant="body2"
            onClick={() => navigate('/notifications')}
            sx={{ cursor: 'pointer' }}
          >
            Notifications
          </Link>
          <Typography variant="body2" color="text.primary">
            Preferences
          </Typography>
        </Breadcrumbs>
      </Box>

      {/* Preferences Form */}
      <PreferencesForm
        preferences={preferences}
        onSave={updatePreferences}
        loading={loading}
      />
    </Container>
  );
};

export default NotificationPreferences;
